<!-- =========================================================================================
  File Name: MailtplEdit.vue
  Description: Mailtpl Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.header-custome {
  margin-bottom: 15px;
  padding-left: 2px;
}
.con-ul-tabs .vs-tabs--ul {
    box-shadow: none !important;
}
</style>
<template>
  <div id="page-user-edit">
    <div class="header-custome">
      <h3>Edit Mail Template</h3>
    </div>
    <vs-alert
      color="danger"
      title="Attendee Not Found"
      :active.sync="mailtpl_not_found"
    >
      <span
        >Mailtpl record with id: {{ $route.params.mailtplId }} not found.</span
      >
      <span>
        <span>Check</span>
        <router-link
          :to="{ name: 'page-mailtpl-list' }"
          class="text-inherit underline"
          >All Mailtpls</router-link
        >
      </span>
    </vs-alert>

    <vx-card v-if="mailtpl_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="activeTab" position="left" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Mail Template" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <edit-tab-account  :data="mailtpl_data" />
            </div>
          </vs-tab>
          <vs-tab label="Short Codes" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <short-codes :data="shortcodes_data" />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import EditTabAccount from "./EditTabAccountJson.vue";
import ShortCodes from "./ShortCodes.vue";

// Store Module
import moduleMailtplManagement from "@/store/mailtpl-management/moduleMailtplManagement.js";
import { bus } from "../../main";
export default {
  components: {
    EditTabAccount,
    ShortCodes,
  },
  data() {
    return {
      mailtpl_data: null,
      mailtpl_not_found: false,
      shortcodes_data: [],
      docName: null,
      collectionName: null,
      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0,
    };
  },
  watch: {
    activeTab() {
      this.fetch_mailtpl_data(this.$route.params.mailtplId);
    },
  },
  methods: {
    fetch_mailtpl_data() {
      if (this.$route.params.DocName != null) {
        let DocName = this.$route.params.DocName;
        let CollectionName = this.$route.params.CollectionName;
        this.$store
          .dispatch("mailtplManagement/fetchMailtpl", {
            DocName,
            CollectionName,
          })
          .then((res) => {
            if(res.status == 200){
              this.$store
                .dispatch("mailtplManagement/fetchGeneralSettings")
                .then((settings) => {
                  this.mailtpl_data = res.data;
                  this.mailtpl_data.projectId = settings.UnlayerProjectId
                    ? settings.UnlayerProjectId
                    : 6232;
                });
            }else{
              this.$router.push('/mailtpl/list'); 
            }
          });
      }
    },
    fetch_shortcodes_data() {
      this.$store.dispatch("mailtplManagement/fetchShortCodes").then((res) => {
        this.shortcodes_data = res.data;
      });
    },
    fetch_mailtpl_data_overview() {
      this.mailtpl_data = null;
      if (this.docName != null) {
        let DocName = this.docName;
        let CollectionName = this.collectionName;

        this.$store
          .dispatch("mailtplManagement/fetchMailtpl", {
            DocName,
            CollectionName,
          })
          .then((res) => {
            this.$store
              .dispatch("mailtplManagement/fetchGeneralSettings")
              .then((settings) => {
                this.mailtpl_data = res.data;
                this.mailtpl_data.projectId = settings.UnlayerProjectId
                  ? settings.UnlayerProjectId
                  : 6232;
                this.mailtpl_data.DocName = DocName;
                this.mailtpl_data.CollectionName = CollectionName;
              });
          });
      }
    },
  },
  created() {
    // Register Module UserManagement Module
    if (!moduleMailtplManagement.isRegistered) {
      this.$store.registerModule("mailtplManagement", moduleMailtplManagement);
      moduleMailtplManagement.isRegistered = true;
    }
    bus.$on("openMailTemp", (data) => {
      this.docName = null;
      this.collectionName = null;
      console.log("data====", data);
      this.docName = data.DocName;
      this.collectionName = data.CollectionName;
      this.fetch_mailtpl_data_overview();
    });
    this.fetch_mailtpl_data();
    this.fetch_shortcodes_data();
  },
};
</script>